import { type ReactNode } from 'react'
import { cn } from '../lib/utils'

interface Props {
  onClick?: () => void
  disabled?: boolean
  className?: string
  ariaLabel?: string
  children: ReactNode
}

// Shared dashed-border tappable surface used for empty-state CTAs and
// inline "create / add" rows. Layout-agnostic: callers compose padding,
// alignment, and content via children + className.
export function DashedButton({ onClick, disabled, className, ariaLabel, children }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'w-full rounded-lg border-2 border-dashed border-border bg-muted/30 hover:bg-muted/50 hover:border-primary/40 transition-colors cursor-pointer disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
    >
      {children}
    </button>
  )
}
